// Copyright (c) 2018 Deere & Company

import {
    updatePipClaimInputOnBlur,
    updateResponsibleAccountsDropDown
} from '../action-creators/claim-details';
import {doesAccountHaveMatch} from '../../shared/services/claim-shared-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';

export const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, pin) =>

    dispatch => {

        if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

            updateResponsibleAccountsDropDown(productAccountId, dealerCollection, pin)(dispatch);
            dispatch(updatePipClaimInputOnBlur('responsibleAccount', productAccountId));

        }

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };



// WEBPACK FOOTER //
// ./src/claim/pip/services/update-responsible-account.js